import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDonateButtonImageUrl } from '../../utils/buttonImage';
import getLocaleMessages from '../../utils/localesMessages';

const { browser } = getLocaleMessages('buttonsV3/common');

class DonateButtonPreview extends Component {
  static propTypes = {
    buttonSize: PropTypes.string,
    showAcceptedCardLogos: PropTypes.bool,
    locale: PropTypes.string,
    country: PropTypes.string,
    buttonLocaleUrls: PropTypes.object,
  };

  getDonateButtonUrl = (...args) => {
    return getDonateButtonImageUrl(...args);
  };

  render() {
    const donateButtonUrl = this.getDonateButtonUrl(
      this.props.buttonSize,
      this.props.showAcceptedCardLogos,
      this.props.locale,
      this.props.country
    );

    return (
      <div className="buttons">
        {donateButtonUrl && <img src={donateButtonUrl} alt={browser.header} />}
      </div>
    );
  }
}
export default DonateButtonPreview;
